export const findMainFamilyHead = (familyHeads) => {
  return (
    familyHeads.find((head) => head.isMain) ||
    (familyHeads.length > 0 ? familyHeads[0] : null)
  )
}

export const findPersonByRelation = (familyHeads, nickname) => {
  return familyHeads.find((head) => head.nickname === nickname) || null
}

export const extractUrlInfo = (pathname) => {
  const parts = pathname.split('/').filter((part) => part)
  return {
    language: parts[0] || null,
    mainFamily: parts[1] || null,
    subFamily: parts[2] || null,
    isHuminer: parts[1] === 'huminer',
  }
}

export const getAncestorPathHelper = (
  language,
  gedId,
  isMainSite,
  familyHeadsBazach,
  familyHeadsHumenir,
  huminerMain,
  bazachMain,
) => {
  const family =
    isMainSite === 'bazach' ? familyHeadsBazach : familyHeadsHumenir
  const ancestor = family.find((head) => head.gedId === gedId)
  if (!ancestor) {
    return null
  }
  if (isMainSite === 'huminer' && ancestor.gedId === huminerMain?.gedId)
    return `/${language}/huminer/`
  if (isMainSite === 'bazach' && ancestor.gedId === bazachMain?.gedId)
    return `/${language}/`
  return isMainSite === 'bazach'
    ? `/${language}/${ancestor.nickname}/`
    : `/${language}/huminer/${ancestor.nickname}/`
}

export const getRelevantIdHelper = (
  ids,
  isMainSite,
  huminerMain,
  bazachMain,
) => {
  if (!Array.isArray(ids) || ids.length === 0) {
    return null
  }
  const ancestor = getCurrentAncestor(isMainSite, bazachMain, huminerMain)
  const found = ids.find((id) => id === ancestor?.gedId)
  return found || ids[0]
}
export const processPersonHelper = (
  language,
  person,
  currentFamilyHead,
  pathPrefix,
  isMainSite,
  huminerMain,
  bazachMain,
  familyHeadsBazach,
  familyHeadsHumenir,
) => {
  if (!person || typeof person !== 'object') {
    throw new TypeError("הפרמטר 'person' צריך להיות אובייקט.")
  }
  const foundInConnections =
      person.connections?.length > 0 &&
      person.connections.includes(currentFamilyHead.gedId)

  const foundInRelation =
      person.relation?.length > 0 &&
      person.relation.some((rel) =>
          rel.ancestorGedId.includes(currentFamilyHead.gedId)
      )
  const isDifferentFamilyTree = !(foundInConnections || foundInRelation)

  let path = `${pathPrefix}person/${person.gedId}`
  if (isDifferentFamilyTree) {
    let ancestor
    if (person.connections && person.connections.length > 0)
      ancestor = getRelevantIdHelper(
        person.connections,
        isMainSite,
        huminerMain,
        bazachMain,
      )
    else if (person.relation && person.relation.length > 0) {
      const currentAncestor = getCurrentAncestor(
        isMainSite,
        bazachMain,
        huminerMain,
      )
      const foundRel = findRelation(person, currentAncestor.gedId)
      if (foundRel) ancestor = currentAncestor.gedId
      else ancestor = person.relation[0].ancestorGedId[0]
    }
    if (ancestor) {
      path = `${getAncestorPathHelper(
        language,
        ancestor,
        isMainSite,
        familyHeadsBazach,
        familyHeadsHumenir,
        huminerMain,
        bazachMain,
      )}person/${person.gedId}`
    }
  }
  return {
    ...person,
    isDifferentFamilyTree,
    path,
  }
}
const findConnection = (person, gedId) =>
  person?.connections?.find((conn) => conn.ancestorGedId === gedId)

const findRelation = (person, gedId) =>
  person?.relation?.find((rel) => rel.ancestorGedId.includes(gedId))

const getCurrentAncestor = (isMainSite, bazachMain, huminerMain) =>
  isMainSite === 'bazach' ? bazachMain : huminerMain

const getFallbackAncestor = (person, currentAncestor) => {
  if (person.connections?.length > 0) {
    const ancestorObj = findConnection(person, currentAncestor.gedId)
    if (ancestorObj) return currentAncestor.gedId
    return person.connections[0].ancestorGedId
  }
  if (person.relation?.length > 0) {
    const foundRel = findRelation(person, currentAncestor.gedId)
    if (foundRel) return currentAncestor.gedId
    return person.relation[0].ancestorGedId[0]
  }
  return null
}

export const getPersonRouteHelper = (
  language,
  person,
  currentFamilyHead,
  isMainSite,
  bazachMain,
  huminerMain,
  pathPrefix,
  familyHeadsBazach,
  familyHeadsHumenir,
) => {
  // Safety check
  if (!person) return ''

  // Direct checks
  const foundConnection = findConnection(person, currentFamilyHead.gedId)
  const foundRelation = findRelation(person, currentFamilyHead.gedId)
  if (
    !foundConnection &&
    !foundRelation &&
    (person.connections?.length > 0 || person.relation?.length > 0)
  ) {
    const currentAncestor = getCurrentAncestor(
      isMainSite,
      bazachMain,
      huminerMain,
    )
    const ancestor = getFallbackAncestor(person, currentAncestor)
    if (ancestor) {
      return `${getAncestorPathHelper(
        language,
        ancestor,
        isMainSite,
        familyHeadsBazach,
        familyHeadsHumenir,
        huminerMain,
        bazachMain,
      )}person/${person.gedId}`
    }
  }
  return `${pathPrefix}person/${person.gedId}`
}
